var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 12.4998C3.33337 12.4998 4.16671 11.6665 6.66671 11.6665C9.16671 11.6665 10.8334 13.3332 13.3334 13.3332C15.8334 13.3332 16.6667 12.4998 16.6667 12.4998V2.49984C16.6667 2.49984 15.8334 3.33317 13.3334 3.33317C10.8334 3.33317 9.16671 1.6665 6.66671 1.6665C4.16671 1.6665 3.33337 2.49984 3.33337 2.49984L3.33337 18.3332",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.443a270f4ec4076973fc1aff93002634.svg";
export { ForwardRef as ReactComponent };